import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "children", "headingLevel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import useMergedRefs from 'hooks/useMergedRefs';
import { usePageTitleAnnouncer } from './PageTitleAnnouncer';
import { useSetDocumentTitle } from './DocumentTitleProvider';
import Heading from 'components/Heading';

// We need to type-cast Heading to a simpler version of itself as TS
// will otherwise be overwhelmed by the polymorphism complexity :(
// "Expression produces a union type that is too complex to represent."
import { jsx as _jsx } from "react/jsx-runtime";
var StyledHeading = styled(Heading).withConfig({
  displayName: "PageTitle__StyledHeading",
  componentId: "sc-13rgblv-0"
})(["&:focus{outline:none;}"]);
var PageTitle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var text = _ref.text,
    children = _ref.children,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? 'h1' : _ref$headingLevel,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var areChildrenText = typeof children === 'string';
  var pageTitle = text || (areChildrenText ? children : '');
  var pageTitleRef = usePageTitleAnnouncer(pageTitle);
  var mergedRefs = useMergedRefs([ref, pageTitleRef]);
  useSetDocumentTitle(pageTitle);
  if (!areChildrenText && text === undefined) {
    // eslint-disable-next-line no-console
    console.warn('PageTitle: Type of the "children" prop is not string. Please provide a string-only label to the PageTitle component via the "text" prop.', children);
  }
  return /*#__PURE__*/_jsx(StyledHeading, _objectSpread(_objectSpread({}, otherProps), {}, {
    forwardedAs: headingLevel,
    tabIndex: -1,
    ref: mergedRefs,
    children: children
  }));
});
PageTitle.displayName = 'PageTitle';
export default PageTitle;